module.exports = __webpack_public_path__ + "34bc775d/img/upload-icon.9179ae4e.svg";